import { render, staticRenderFns } from "./BaseSingleDropdown.vue?vue&type=template&id=3c5e1fd3&scoped=true"
import script from "./BaseSingleDropdown.vue?vue&type=script&lang=js"
export * from "./BaseSingleDropdown.vue?vue&type=script&lang=js"
import style0 from "./BaseSingleDropdown.vue?vue&type=style&index=0&id=3c5e1fd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5e1fd3",
  null
  
)

export default component.exports